import React, { useState } from 'react';

import FetchApi from '../../../customhooks/Functionapi';
import moment from 'moment/moment';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import HourglassTopRoundedIcon from '@mui/icons-material/HourglassTopRounded';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';

// สถานะของแต่ละขั้น: อนุมัติแล้ว / รับงานแล้วกำลังดำเนินการ / ยังไม่ถึงคิว
function getStepState(item) {
  if (item.activerecieved == 1 && item.active == 1) {
    return { key: 'done', label: 'อนุมัติแล้ว', color: '#43a047', bg: '#e8f5e9', icon: <CheckRoundedIcon sx={{ fontSize: 20 }} /> };
  }
  if (item.activerecieved == 1) {
    return { key: 'progress', label: 'กำลังดำเนินการ', color: '#ef6c00', bg: '#fff3e0', icon: <HourglassTopRoundedIcon sx={{ fontSize: 18 }} /> };
  }
  return { key: 'waiting', label: 'รอดำเนินการ', color: '#90a4ae', bg: '#f5f7f8', icon: <PersonOutlineRoundedIcon sx={{ fontSize: 20 }} /> };
}

function formatDate(value) {
  return value ? moment(value).format('DD/MM/yyyy HH:mm:ss') : '-';
}

export default function StepFlowProcess(props) {
  const FetchApis = new FetchApi();
  const [datalist, setDatalist] = useState([]);

  React.useEffect(() => {
    flowlistStep()
  }, [])

  async function flowlistStep() {
    await FetchApis.FethcGet(`/flowrunsystem/flowSteplistByJourId/${props.jourID}`).then(res => {
      if (res) {
        setDatalist(res.data);
      }
    })
  }

  const doneCount = datalist.filter(item => getStepState(item).key === 'done').length;
  const percent = datalist.length ? Math.round((doneCount / datalist.length) * 100) : 0;

  return (
    <Box>
      <Box sx={{ mb: 2.5, p: 1.5, borderRadius: 2, bgcolor: '#f4f6f9', border: '1px solid #e3e6ea' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, fontSize: 13 }}>
          <Box sx={{ color: '#546e7a', fontWeight: 600 }}>ความคืบหน้า</Box>
          <Box sx={{ color: '#43a047', fontWeight: 700 }}>{doneCount} / {datalist.length} ขั้นตอน</Box>
        </Box>
        <LinearProgress
          variant="determinate"
          value={percent}
          sx={{ height: 8, borderRadius: 999, bgcolor: '#e3e6ea', '& .MuiLinearProgress-bar': { borderRadius: 999, bgcolor: '#43a047' } }}
        />
      </Box>

      {datalist.map((item, indix) => {
        const step = getStepState(item);
        const isLast = indix === datalist.length - 1;
        return (
          <Box key={indix} sx={{ display: 'flex', gap: 2 }}>
            {/* เส้น timeline + จุดสถานะ */}
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 }}>
              <Box sx={{
                width: 38, height: 38, borderRadius: '50%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                bgcolor: step.key === 'waiting' ? '#fff' : step.color,
                color: step.key === 'waiting' ? step.color : '#fff',
                border: step.key === 'waiting' ? '2px dashed #cfd8dc' : 'none',
                boxShadow: step.key === 'progress' ? '0 0 0 5px rgba(239,108,0,0.15)' : 'none',
              }}>
                {step.icon}
              </Box>
              {!isLast && (
                <Box sx={{
                  flex: 1, minHeight: 24, my: 0.5,
                  borderLeft: step.key === 'done' ? '3px solid #43a047' : '3px dashed #cfd8dc',
                }} />
              )}
            </Box>

            {/* การ์ดรายละเอียด */}
            <Box sx={{
              flex: 1, mb: isLast ? 0 : 2, p: 1.5,
              borderRadius: 2,
              border: '1px solid',
              borderColor: step.key === 'progress' ? '#ffcc80' : '#e3e6ea',
              bgcolor: '#fff',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, flexWrap: 'wrap' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                  <Box sx={{ fontWeight: 700, fontSize: 14.5, color: '#263238' }}>คุณ {item.userbyflow}</Box>
                  {item.nameStatus && (
                    <Box sx={{ px: 1, py: 0.25, borderRadius: 999, bgcolor: '#eef4ff', color: '#1e88e5', fontSize: 11, fontWeight: 600 }}>
                      {item.nameStatus}
                    </Box>
                  )}
                </Box>
                <Box sx={{ px: 1, py: 0.25, borderRadius: 999, bgcolor: step.bg, color: step.color, fontSize: 11, fontWeight: 700 }}>
                  {step.label}
                </Box>
              </Box>

              {item.departments && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5, fontSize: 12, color: '#78909c' }}>
                  <ApartmentRoundedIcon sx={{ fontSize: 14 }} />
                  {item.departments}
                </Box>
              )}

              <Box sx={{ display: 'flex', gap: 2, mt: 1, pt: 1, borderTop: '1px solid #f1f3f5', flexWrap: 'wrap', fontSize: 12 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                  <CalendarTodayRoundedIcon sx={{ fontSize: 14, color: '#ef6c00' }} />
                  <Box component="span" sx={{ color: '#90a4ae' }}>{item.statusType == '100' ? 'วันที่สร้าง' : 'วันที่รับ'}</Box>
                  <Box component="span" sx={{ color: '#37474f', fontWeight: 600 }}>
                    {item.activerecieved == 1 ? formatDate(item.Startdatetime) : '-'}
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                  <EventAvailableRoundedIcon sx={{ fontSize: 15, color: '#43a047' }} />
                  <Box component="span" sx={{ color: '#90a4ae' }}>วันที่อนุมัติ</Box>
                  <Box component="span" sx={{ color: '#37474f', fontWeight: 600 }}>
                    {item.active == 1 ? formatDate(item.Enddatetime) : '-'}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
